import axios from 'axios';
import { BASE_URL } from '../settings';
import { configureAuthInterceptors } from './configureAuthInterceptors';

let authFailureHandler = () => {};

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    },
});

export const setAxiosAuthFailureHandler = handler => {
    authFailureHandler = typeof handler === 'function' ? handler : () => {};
};

export default configureAuthInterceptors(axiosInstance, {
    baseURL: BASE_URL,
    onAuthFailure: error => authFailureHandler(error),
});
